// idleStamp — where the foreground idle clock is kept between mounts (PROD-252, P17 step 10).
//
// ★ ONE KEY, THROUGH authStorage ONLY. `orella-idle-clock` holds
//   { lastActivityAt, hiddenAt } as JSON and nothing else: two epochs, no PHI. It goes through
//   authGet / authSet / authRemove, so it lives exactly where the session does: localStorage
//   on native (it survives a WKWebView recycle), sessionStorage on the web (it dies with the
//   tab). The key name carries none of TOKEN, AUTH, SESSION, REFRESH or USER, so
//   check-auth-storage does not count it as a credential.
//
// ★ AN UNREADABLE VALUE IS EXPIRED, NOT FRESH (P17 Q3). Garbage, a non-object, a missing
//   lastActivityAt or a read that throws all return { lastActivityAt: NaN }, which
//   sessionReturn.idleStartAt reads as expired. Only an ABSENT value is a fresh clock.
//   (authGet itself answers null when the storage throws; this layer cannot tell that
//   from absent, and says so here rather than pretend.)
import { authGet, authSet, authRemove } from './authStorage'

export const IDLE_CLOCK_KEY = 'orella-idle-clock'

const UNREADABLE = Object.freeze({ lastActivityAt: NaN, hiddenAt: null })

export function readIdleStamp() {
  try {
    const raw = authGet(IDLE_CLOCK_KEY)
    if (raw === null || raw === undefined) return { lastActivityAt: null, hiddenAt: null }
    const v = JSON.parse(raw)
    if (!v || typeof v !== 'object' || !('lastActivityAt' in v)) return { ...UNREADABLE }
    return { lastActivityAt: v.lastActivityAt, hiddenAt: v.hiddenAt ?? null }
  } catch (_) {
    return { ...UNREADABLE }
  }
}

export function writeIdleStamp({ lastActivityAt, hiddenAt = null } = {}) {
  try {
    authSet(IDLE_CLOCK_KEY, JSON.stringify({ lastActivityAt, hiddenAt: hiddenAt ?? null }))
  } catch (_) { /* a stamp that cannot be written reads back as absent or stale; never throws */ }
}

export function clearIdleStamp() {
  try { authRemove(IDLE_CLOCK_KEY) } catch (_) {}
}
